var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"mt-4 ml-4"},[_c('div',[_vm._v(" 医療請求のテストプレビュー版は、12月の月次アップデート以降に公開予定です。 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }